// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import language JSON files
import enTranslation from './translations/en.json';
import hiTranslation from './translations/hi.json';
import esTranslation from './translations/es.json';

// Initialize i18next
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: enTranslation },
      hi: { translation: hiTranslation },
      es: { translation: esTranslation }
    },
    lng: 'en', // default language
    fallbackLng: 'en', // fallback language
    interpolation: {
      escapeValue: false // React already escapes by default
    }
  });

export default i18n;
